<div class="relative flex items-center">
  @if (showStartPrompt()) {
    <lib-auto-start-prompt (handleStart)="onStartPromptStart()" (handleExpand)="onStartPromptExpand()"></lib-auto-start-prompt>
  } @else {
    <div [ngClass]="showInlineControls() ? 'flex items-center gap-[8px] rounded-[99px] bg-states-purple-light pr-[4px]' : ''">
      <button
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        (click)="toggleOverlay()"
        class="flex size-10 items-center justify-center rounded-full hover:cursor-pointer"
        [ngClass]="{
          'shadow-[0px_0px_6px_0px_rgba(10,72,131,0.24)]': showInlineControls(),
          'bg-background-light-blue text-primary-blue': isDefaultButtonState(),
          'bg-states-purple text-text-white': buttonState() === AutoDraftState.InProgress,
          'bg-states-purple-light': !isDefaultButtonState() && buttonState() !== AutoDraftState.InProgress,
          'text-states-purple':
            !isDefaultButtonState() &&
            (buttonState() === AutoDraftState.Inactive ||
              buttonState() === AutoDraftState.Loading ||
              buttonState() === AutoDraftState.Enhancing),
          'text-states-purple-dark':
            buttonState() === AutoDraftState.Paused || buttonState() === AutoDraftState.Stopped || buttonState() === AutoDraftState.Error
        }"
        [libUiTooltip]="autoDraftTooltip"
        tooltipPosition="bottom"
        [attr.aria-label]="'navigation_header_auto_draft' | translate"
      >
        @if (buttonState() === AutoDraftState.Loading || buttonState() === AutoDraftState.Enhancing) {
          <ng-lottie size="md" class="h-[24px] w-[24px]" currentColor [options]="loadingLottieOptions"></ng-lottie>
        } @else {
          @if (buttonState() === AutoDraftState.InProgress) {
            <ng-lottie
              size="md"
              class="h-[24px] w-[24px]"
              currentColor
              libVolumeReactiveLottie
              [options]="autodraftInProgressLottieOptions"
            ></ng-lottie>
          } @else if (buttonState() === AutoDraftState.Paused) {
            <svg-icon size="md" [key]="'px-16-sound-off'"></svg-icon>
          } @else {
            <svg-icon size="md" [key]="'px-16-eq'"></svg-icon>
          }
        }
      </button>
      @if (showInlineControls()) {
        <lib-auto-draft-controls variant="navbar"></lib-auto-draft-controls>
      }
    </div>
    <ng-template #autoDraftTooltip>
      <span class="typo-h7-book text-center">
        {{ 'navigation_header_auto_draft' | translate }}
      </span>
    </ng-template>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOverlayOpen()"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayHasBackdrop]="false"
      [cdkConnectedOverlayOffsetY]="15"
      [cdkConnectedOverlayOffsetX]="15"
    >
      <lib-auto-draft-overlay
        #overlayRef
        #overlayDrag="cdkDrag"
        cdkDrag
        cdkDragBoundary=".cdk-overlay-connected-position-bounding-box"
        [cdkDragFreeDragPosition]="initialDragPosition()"
        [cdkDragRef]="overlayDrag"
        (cdkDragEnded)="overlayRef.onDragEnded($event)"
        (closeOverlay)="closeOverlay()"
        class="auto-draft-overlay cursor-move"
      ></lib-auto-draft-overlay>
    </ng-template>
  }

  @if (showAppointmentIndicator() && !showStartPrompt() && !showInlineControls()) {
    <div class="notification-dot pointer-events-none absolute right-[-11px] top-[-11px] h-[28px] w-[28px] rounded-full"></div>
    <div class="pointer-events-none absolute right-[-2px] top-[-2px] h-[10px] w-[10px] rounded-full bg-states-purple"></div>
  }
</div>
